import React from "react";
import { useState } from "react";
import ArrowDownBlueIcon from "../../../resources/arrow-down-blue.svg";
import ArrowUpBlueIcon from "../../../resources/arrow-up-blue.svg";

const AbsoluteDrawer = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`bottom-0 left-0 right-0 absolute z-20 overflow-hidden rounded-t-xl bg-full-white ${open ? "top-6" : "h-[120px]"}`}
      style={{
        display: "grid",
        gridTemplateRows: "auto 1fr",
        boxShadow: "0px 0px 6px #00000080",
      }}
      onClick={open ? null : () => setOpen(true)}
    >
      <div
        className="flex items-center flex-col bg-white"
        onClick={() => setOpen((v) => !v)}
      >
        <img
          src={open ? ArrowDownBlueIcon : ArrowUpBlueIcon}
          alt="Toggle"
          className="cursor-pointer opacity-40"
        />
      </div>
      <div className="relative">{children}</div>
    </div>
  );
};

export default AbsoluteDrawer;
